// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./react/" + ({"622":"TournamentResultPrint","884":"admin","973":"ChartComponents"}[chunkId] || chunkId) + "" + {"123":"9cc0e338f15a074823de","130":"52eabb4ca7e604f81f7c","622":"2a0c2225beb65a2eb9f5","884":"84858156865b4db000b5","933":"716855feadb7f77e7a1b","973":"19c7b289d58bcdfe47b4"}[chunkId] + ".bundle.js";
};